import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueCryptojs from "vue-cryptojs";

import moment from "vue-moment";

import "./sass/main.scss";

import GSignInButton from "vue-google-signin-button";
Vue.use(GSignInButton);

Vue.config.productionTip = false;
Vue.use(moment);

Vue.use(VueCryptojs);

new Vue({
  router,
  store,
  vuetify,

  render: function (h) {
    return h(App);
  },
}).$mount("#app");
